import {AbstractService} from 'services/AbstractService';

const COLUMNS_PRESETS_LIST_URL = '/api/columnpresets';
const COLUMN_PRESET_DETAILS_URL = '/api/columnpresets/{0}';

export class ColumnPresetsService extends AbstractService {

  get (accountId) {
    return this.client.get(COLUMNS_PRESETS_LIST_URL, {}, {accountId});
  }

  create (accountId, name, columns, scope, view) {
    return this.client.post(COLUMNS_PRESETS_LIST_URL, {
      name, columns, scope, view
    }, {accountId});
  }

  update (accountId, presetId, name, columns, scope, view) {
    return this.client.put(COLUMN_PRESET_DETAILS_URL.format(presetId), {
      name, columns, scope, view
    }, {accountId});
  }

  delete (accountId, presetId) {
    return this.client.delete(COLUMN_PRESET_DETAILS_URL.format(presetId), {}, {}, {}, {accountId});
  }

}
